angular.module("ainapp")
    .controller("productUpdateController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
        function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Product Update";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.ProductType = "Product";
            $scope.PageName = "Product Upload";
            if ($state.current.name == "productUpload") {
                $scope.ProductType = "Product";
                $scope.PageName = "Product Upload";
            } else if ($state.current.name == "serviceUpload") {
                $scope.ProductType = "Service";
                $scope.PageName = "Service Upload";
            } else if ($state.current.name == "assetUpload") {
                $scope.ProductType = "Asset";
                $scope.PageName = "Asset Upload";
            }


            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            MainService.SecondLevelProductsbyType($scope.ProductType).then(function (response) {
                $scope.Categories = response.data;
            });

            $scope.Init = function () {

                $scope.Products = [];
                $scope.filter = {
                    CategoryId: ""
                };

            }
            $scope.Init();

            $scope.applyCategory = function () {
                if ($scope.filter.CategoryId != "") {
                    angular.forEach($scope.Products, function (e) {
                        e.ParentId = $scope.filter.CategoryId;
                    })
                }
            }


            var oFileIn;

            $(function () {
                oFileIn = document.getElementById('my_file_input');
                if (oFileIn.addEventListener) {
                    oFileIn.addEventListener('change', filePicked, false);
                }
            });

            function filePicked(oEvent) {
                var oFile = oEvent.target.files[0];
                var sFilename = oFile.name;
                var reader = new FileReader();

                reader.onload = function (e) {
                    var data = e.target.result;
                    var cfb = XLSX.read(data, {
                        type: 'binary'
                    });
                    console.log(cfb)
                    cfb.SheetNames.forEach(function (sheetName) {
                        var sCSV = XLS.utils.make_csv(cfb.Sheets[sheetName]);
                        var oJS = XLS.utils.sheet_to_json(cfb.Sheets[sheetName]);

                        angular.forEach(oJS, function (e) {

                            e.ProductCode = e.ProductCode;
                            e.Name = e.Name;
                            e.NameAr = e.NameAr;
                            e.BarCode = e.BarCode;
                            e.SellPrice = e.SellPrice;
                            e.PurchasePrice = e.PurchasePrice;
                            e.UnitName = e.Unit;
                            e.ProductType = $scope.ProductType;
                            e.BrandName = e.Brand;
                            e.Manufacture = e.Manufacture;
                            e.CountryName = e.Country;
                            e.ConvertingValue = e.ConvertingValue;
                            e.ConvertingUnit = e.ConvertingUnit;
                            e.HSCode = e.HSCode;
                            e.Weight = e.Weight;
                            e.Category = e.Category;
                            e.CategoryName = e.Category;
                            e.Description = e.Description;
                            e.VatType = e.VatType;

                            e.Field1 = e.Field1;
                            e.Field2 = e.Field2;
                            e.Field3 = e.Field3;
                            e.Field4 = e.Field4;
                            e.Field5 = e.Field5;
                            e.Field6 = e.Field6;
                            e.Field7 = e.Field7;
                            e.Field8 = e.Field8;
                            e.Field9 = e.Field9;
                            e.Field10 = e.Field10;
                            e.Field11 = e.Field11;
                            e.Field12 = e.Field12;
                            e.Field13 = e.Field13;
                            e.Field14 = e.Field14;
                            e.Field15 = e.Field15;
                            e.Field16 = e.Field16;
                            e.Field17 = e.Field17;
                            e.Field18 = e.Field18;
                            e.Field19 = e.Field19;
                            e.Field20 = e.Field20;
                            e.Field21 = e.Field21;
                            e.Field22 = e.Field22;
                            e.Field23 = e.Field23;
                            e.Field24 = e.Field24;
                            e.Field25 = e.Field25;

                            e.Length = e.Length;
                            e.Width = e.Width;
                            e.Height = e.Height;
                            e.Volume = e.Volume;
                            e.GrossWeight = e.GrossWeight;
                             e.Branches = e.Branches;
                            e.VATPercentage = e.VATPercentage;


                            //                            angular.forEach($scope.Categories, function (cat) {
                            //                                if (cat.Name == e.Category) {
                            //                                    e.ParentId = cat.Id;
                            //                                }
                            //                            })
                        });

                        $scope.Products = oJS;
                        $scope.$apply();
                    });
                };

                reader.readAsBinaryString(oFile);
            }


            $scope.uploadProducts = function (temp) {

                var fail = 0;
                angular.forEach($scope.Products, function (e) {
                    e.ProductBranchs = [];
                    if(e.Branches != null && e.Branches != "" && e.Branches != undefined){
                        var arr = e.Branches? e.Branches.split(";") : [];
                        e.ProductBranchs = arr;
                    }
                })

                if (fail == 1) {
                    toastr.warning("Invalid Format! Name, Unit needed in all rows");
                } else {

                    $scope.load = true;
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.UpdateProductList($scope.Products).then(function (response) {
                        if (response.data == 1) {
                            toastr.success("Success");
                            $scope.Init();
                        } else {
                            toastr.warning("Failed Please Try Again, Plesae chek any product uploaded or not, if uploaded continue from the next");
                        }
                        $scope.load = false;
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error, Plesae chek any product uploaded or not, if uploaded continue from the next");
                        $scope.load = false;
                        $.LoadingOverlay("hide");
                    })

                }

            }



            //            $scope.uploadProducts = function (temp) {
            //
            //                angular.forEach($scope.Products, function (e) {
            //
            //                    var temp = [];
            //                    temp.push(e);
            //
            //                    $scope.load = true;
            //                    $.LoadingOverlay("show", {
            //                        image: "images/load.gif",
            //                    });
            //
            //                    MainService.UploadProductList(temp).then(function (response) {
            //                        if (response.data == 1) {
            //                            toastr.success("Success");
            //                            // $scope.Init();
            //                        } else {
            //                            toastr.warning("Failed Please Try Again");
            //                        }
            //                        $scope.load = false;
            //                        $.LoadingOverlay("hide");
            //                    }, function (err) {
            //                        toastr.error("Network Error");
            //                        $scope.load = false;
            //                        $.LoadingOverlay("hide");
            //                    })
            //
            //                })
            //            }


        }])
